import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";
import {
  UserForSharingCampaign,
  UserThatShareCampaign,
} from "../types/apiTypes";
import { RequestMethods } from "../types/enums";
import { CampaignId } from "../types";

const path = "/user-campaigns";

export const shareCampaignApi = createApi({
  reducerPath: "shareCampaignApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["shared-users"],
  endpoints: (builder) => ({
    getUsersThatShareCampaign: builder.query<UserThatShareCampaign[], string>({
      query: (campaign_id) => ({
        url: `${path}/${campaign_id}/users`,
        method: RequestMethods.GET,
      }),
      providesTags: ["shared-users"],
    }),

    updateUsersPermissions: builder.mutation<
      Response,
      { users: UserForSharingCampaign[] } & CampaignId
    >({
      query: ({ campaign_id, ...body }) => ({
        url: `${path}/${campaign_id}/users`,
        method: RequestMethods.POST,
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetUsersThatShareCampaignQuery,
  useUpdateUsersPermissionsMutation,
} = shareCampaignApi;
